

export class FuelCalibrationOutputByIdOutPut implements IFuelCalibrationOutputByIdOutPut {
    /** The auto-generated id of the fuel calibration master */
    fuel_calibration_id!: number;
    /** The auto-generated id of the branch details master */
    branch_detail_id!: number;
    /** The auto-generated id of the company details master */
    company_details_id!: number;
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id!: number;
    /** The auto-generated id of the device model port specification master */
    device_model_port_specification_id!: number;
    /** The sensor output unit must be Voltage,Liter,Gallon,percentage */
    sensor_output_unit!: string;
    /** The conversion factor */
    conversion_factor!: number;
    /** The range 50 character */
    range!: string;
    /** The sensor output unit must be Automatic,Manual */
    calibration_type!: string;
    /** The tank capacity */
    tank_capacity!: number;
    /** The empty tank reading */
    empty_tank_reading!: number;
    /** The half tank reading */
    half_tank_reading!: number;
    /** The full tank reading */
    full_tank_reading!: number;
    /** The filled up liter */
    filled_up_liter!: number;
    status!: number;

    constructor(data?: IFuelCalibrationOutputByIdOutPut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fuel_calibration_id = _data["fuel_calibration_id"];
            this.branch_detail_id = _data["branch_detail_id"];
            this.company_details_id = _data["company_details_id"];
            this.vehicle_details_id = _data["vehicle_details_id"];
            this.device_model_port_specification_id = _data["device_model_port_specification_id"];
            this.sensor_output_unit = _data["sensor_output_unit"];
            this.conversion_factor = _data["conversion_factor"];
            this.range = _data["range"];
            this.calibration_type = _data["calibration_type"];
            this.tank_capacity = _data["tank_capacity"];
            this.empty_tank_reading = _data["empty_tank_reading"];
            this.half_tank_reading = _data["half_tank_reading"];
            this.full_tank_reading = _data["full_tank_reading"];
            this.filled_up_liter = _data["filled_up_liter"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): FuelCalibrationOutputByIdOutPut {
        data = typeof data === 'object' ? data : {};
        let result = new FuelCalibrationOutputByIdOutPut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fuel_calibration_id"] = this.fuel_calibration_id;
        data["branch_detail_id"] = this.branch_detail_id;
        data["company_details_id"] = this.company_details_id;
        data["vehicle_details_id"] = this.vehicle_details_id;
        data["device_model_port_specification_id"] = this.device_model_port_specification_id;
        data["sensor_output_unit"] = this.sensor_output_unit;
        data["conversion_factor"] = this.conversion_factor;
        data["range"] = this.range;
        data["calibration_type"] = this.calibration_type;
        data["tank_capacity"] = this.tank_capacity;
        data["empty_tank_reading"] = this.empty_tank_reading;
        data["half_tank_reading"] = this.half_tank_reading;
        data["full_tank_reading"] = this.full_tank_reading;
        data["filled_up_liter"] = this.filled_up_liter;
        data["status"] = this.status;
        return data; 
    }
}

export interface IFuelCalibrationOutputByIdOutPut {
    /** The auto-generated id of the fuel calibration master */
    fuel_calibration_id: number;
    /** The auto-generated id of the branch details master */
    branch_detail_id: number;
    /** The auto-generated id of the company details master */
    company_details_id: number;
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id: number;
    /** The auto-generated id of the device model port specification master */
    device_model_port_specification_id: number;
    /** The sensor output unit must be Voltage,Liter,Gallon,percentage */
    sensor_output_unit: string;
    /** The conversion factor */
    conversion_factor: number;
    /** The range 50 character */
    range: string;
    /** The sensor output unit must be Automatic,Manual */
    calibration_type: string;
    /** The tank capacity */
    tank_capacity: number;
    /** The empty tank reading */
    empty_tank_reading: number;
    /** The half tank reading */
    half_tank_reading: number;
    /** The full tank reading */
    full_tank_reading: number;
    /** The filled up liter */
    filled_up_liter: number;
    status: number;
}

